module.exports = __webpack_public_path__ + "static/og-31eff18886374ac6ef958faee8373e23.jpg";